import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "left-filter-section" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "brg-input-section multi-date-picker-activator" };
const _hoisted_4 = { class: "brg-color-grey-800 text-subtitle-2" };
const _hoisted_5 = { class: "brg-input-section multi-month-picker-activator" };
const _hoisted_6 = { class: "brg-color-grey-800 text-subtitle-2" };
const _hoisted_7 = { class: "right-filter-section" };
import { computed, watch, ref, } from 'vue';
import { i18n } from '@/locales';
import SubControllerTemplate from '@/templates/SubControllerTemplate.vue';
import Select from '@/components/Form/Select.vue';
import SearchInput from '@/components/Form/SearchInput.vue';
import { workerProfitSearchDateType, workerProfitSearchDateTypeOptionList, } from '@/constants/workerProfit/workerProfitSearchDateTypeOptionList';
import { workerProfitSearchTypeOptionList } from '@/constants/workerProfit/workerProfitSearchTypeOptionList';
import { workerProfitIsWithholdingTaxTypeOptionList } from '@/constants/workerProfit/workerProfitIsWithholdingTaxTypeOptionList';
import { workerProfitStoreTypeOptionList } from '@/constants/workerProfit/workerProfitStoreTypeOptionList';
import { workerProfitUseYnTypeOptionList } from '@/constants/workerProfit/workerProfitUseYnTypeOptionList';
import { format } from 'date-fns';
import { afterDays, afterMonths, beforeDays, beforeMonths, } from '@/utils/time';
import { makeRangePickerDate } from '@/utils';
import dateFormatType from '@/constants/dateFormatType';
import SearchInputWrapper from '@/components/Form/SearchInputWrapper.vue';
import vuexStore from '@/vuex-store';
const lc = 'views.worker.worker_profit.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubController',
    setup(__props) {
        // PAGE:: 라이더 수익
        const locale = {
            pageTitle: i18n.t(`${lc}page_title`),
            searchDateType: i18n.t(`${lc}search_date_type`),
            selectPeriod: i18n.t(`${lc}select_period`),
            workerUseYn: i18n.t(`${lc}worker_use_yn`),
            storeType: i18n.t(`${lc}store_type`),
            isWithholdingTax: i18n.t(`${lc}is_withholding_tax`),
            searchPlaceholder: i18n.t('common.input_field_placeholder', {
                field: i18n.t('common.search_word'),
            }),
            reset: i18n.t('common.reset'),
        };
        // 조회 타입
        const searchDateType = computed(() => vuexStore.state.workerProfit.filterOption.searchDateType);
        const handleChangeSearchDateTypeSelector = (value) => {
            vuexStore.dispatch('workerProfit/setFilterOption', {
                searchDateType: value,
            });
        };
        // 조회 기간
        const fromDate = computed(() => vuexStore.state.workerProfit.filterOption.fromDate);
        const toDate = computed(() => vuexStore.state.workerProfit.filterOption.toDate);
        const selectedPeriod = computed(() => [
            fromDate.value,
            toDate.value,
        ]);
        const formattedPeriod = computed(() => selectedPeriod.value.join(' ~ '));
        /**
         * 조회 기간 변경 핸들러
         * 조회 타입에 따라 변경 된 값을 저장
         */
        const handleChangeDatePicker = (value) => {
            const isSearchDateTypeDaily = searchDateType.value === workerProfitSearchDateType.DAILY;
            const dateFormat = isSearchDateTypeDaily ? dateFormatType.DATE : dateFormatType.MONTH;
            const range = makeRangePickerDate(value, dateFormat);
            vuexStore.dispatch('workerProfit/setFilterOption', {
                fromDate: range[0],
                toDate: range[1],
            });
        };
        const resetPeriodBySearchDateType = (type) => {
            const resetMethod = type === workerProfitSearchDateType.DAILY ? beforeDays : beforeMonths;
            const resetFormat = type === workerProfitSearchDateType.DAILY ? dateFormatType.DATE : dateFormatType.MONTH;
            const today = new Date();
            const initialTo = format(today, resetFormat);
            const initialFrom = format(resetMethod(today, 1), resetFormat);
            vuexStore.dispatch('workerProfit/setFilterOption', {
                toDate: initialTo,
                fromDate: type === workerProfitSearchDateType.DAILY ? initialFrom : initialTo,
            });
        };
        // 조회 기간(일별) - 설정값
        const isSearchDateTypeDaily = computed(() => searchDateType.value === workerProfitSearchDateType.DAILY);
        const today = ref(new Date());
        const selectedDateFormat = dateFormatType.DATE;
        // 최소 선택 가능일
        const minDate = ref('');
        // 최대 선택 가능일
        const maxDate = ref(format(today.value, selectedDateFormat));
        const resetMinMaxDate = () => {
            minDate.value = '';
            maxDate.value = format(today.value, selectedDateFormat);
        };
        const handleStartRangeDatePicker = (startDate) => {
            const dateFormatStartDate = new Date(startDate);
            minDate.value = format(beforeDays(dateFormatStartDate, 30), selectedDateFormat);
            const isMaxLaterThanToday = afterDays(dateFormatStartDate, 30) > today.value.getTime();
            // 처음 선택한 날로부터 계산된 31일 초과된 날이 오늘보다 이후일 경우 오늘날짜로 비활성화
            if (isMaxLaterThanToday) {
                maxDate.value = format(afterDays(today.value, 0), selectedDateFormat);
                return;
            }
            maxDate.value = format(afterDays(dateFormatStartDate, 30), selectedDateFormat);
        };
        const handleEndRangeDatePicker = () => {
            resetMinMaxDate();
        };
        // 조회 기간(월별) - 설정값
        const selectedMonthFormat = dateFormatType.MONTH;
        // 최소 선택 가능월
        const minMonth = ref('');
        // 최대 선택 가능일
        const maxMonth = ref(format(today.value, selectedMonthFormat));
        const resetMinMaxMonth = () => {
            minMonth.value = '';
            maxMonth.value = format(today.value, selectedMonthFormat);
        };
        const handleStartRangeMonthPicker = (startDate) => {
            const dateFormatStartDate = new Date(startDate);
            minMonth.value = format(beforeMonths(dateFormatStartDate, 2), selectedMonthFormat);
            const isMaxLaterThanToday = afterMonths(dateFormatStartDate, 2) > today.value.getTime();
            // 처음 선택한 날로부터 계산된 31일 초과된 날이 오늘보다 이후일 경우 오늘날짜로 비활성화
            if (isMaxLaterThanToday) {
                maxMonth.value = format(afterMonths(today.value, 0), selectedMonthFormat);
                return;
            }
            maxMonth.value = format(afterMonths(dateFormatStartDate, 2), selectedMonthFormat);
        };
        const handleEndRangeMonthPicker = () => {
            resetMinMaxMonth();
        };
        watch(() => searchDateType.value, (value) => {
            resetPeriodBySearchDateType(value);
            if (value === workerProfitSearchDateType.DAILY) {
                resetMinMaxDate();
                return;
            }
            resetMinMaxMonth();
        });
        // 라이더 상태
        const workerUseYn = computed(() => vuexStore.state.workerProfit.filterOption.useYn);
        const handleChangeWorkerUseYnSelector = (value) => {
            vuexStore.dispatch('workerProfit/setFilterOption', {
                useYn: value,
            });
        };
        // 가맹점 종류
        const storeType = computed(() => vuexStore.state.workerProfit.filterOption.storeType);
        const handleChangeStoreTypeSelector = (value) => {
            vuexStore.dispatch('workerProfit/setFilterOption', {
                storeType: value,
            });
        };
        // 원천세 여부
        const isWithholdingTax = computed(() => vuexStore.state.workerProfit.filterOption.isWithholdingTax);
        const handleChangeIsWithholdingTaxSelector = (value) => {
            vuexStore.dispatch('workerProfit/setFilterOption', {
                isWithholdingTax: value,
            });
        };
        // 검색 타입
        const searchType = computed(() => vuexStore.state.workerProfit.filterOption.searchType);
        const handleChangeSearchTypeSelector = (value) => {
            vuexStore.dispatch('workerProfit/setFilterOption', {
                searchType: value,
            });
        };
        // 검색어
        const searchKey = computed(() => vuexStore.state.workerProfit.filterOption.searchKey);
        const handleChangeSearchKeyInput = (value) => {
            vuexStore.dispatch('workerProfit/setFilterOption', {
                searchKey: value,
            });
        };
        /**
         * 초기화 버튼 클릭 핸들러
         */
        const handleClickResetBtn = () => {
            vuexStore.dispatch('workerProfit/resetStore');
        };
        return (_ctx, _cache) => {
            const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_vue_datepicker = _resolveComponent("vue-datepicker");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createBlock(SubControllerTemplate, null, {
                toolsSlot: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", null, [
                            _createCommentVNode(" 조회 타입 "),
                            _createVNode(Select, {
                                width: 100,
                                title: locale.searchDateType,
                                value: searchDateType.value,
                                items: _unref(workerProfitSearchDateTypeOptionList),
                                "on-change": handleChangeSearchDateTypeSelector
                            }, null, 8 /* PROPS */, ["title", "value", "items"])
                        ]),
                        _createCommentVNode(" 조회 기간(일별) "),
                        (isSearchDateTypeDaily.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(_component_vue_datepicker, {
                                    modelValue: selectedPeriod.value,
                                    "onUpdate:modelValue": [
                                        _cache[0] || (_cache[0] = ($event) => ((selectedPeriod).value = $event)),
                                        handleChangeDatePicker
                                    ],
                                    range: "",
                                    position: "left",
                                    format: _unref(selectedDateFormat),
                                    "model-type": _unref(selectedDateFormat),
                                    "min-date": minDate.value,
                                    "max-date": maxDate.value,
                                    onRangeStart: handleStartRangeDatePicker,
                                    onRangeEnd: handleEndRangeDatePicker
                                }, {
                                    "action-row": _withCtx((props) => [
                                        _createVNode(_component_vue_datepicker_action_row, _normalizeProps(_guardReactiveProps(props)), null, 16 /* FULL_PROPS */)
                                    ]),
                                    "dp-input": _withCtx(() => [
                                        _createElementVNode("div", _hoisted_3, [
                                            _createElementVNode("span", _hoisted_4, _toDisplayString(locale.selectPeriod), 1 /* TEXT */),
                                            _createVNode(_component_v_text_field, {
                                                value: formattedPeriod.value,
                                                variant: "outlined",
                                                density: "compact",
                                                readonly: "",
                                                "hide-details": "",
                                                class: "mt-1",
                                                "bg-color": "white",
                                                "prepend-inner-icon": "mdi-calendar-month-outline"
                                            }, null, 8 /* PROPS */, ["value"])
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "format", "model-type", "min-date", "max-date"])
                            ]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createCommentVNode(" 조회 기간(월별) "),
                                _createElementVNode("div", null, [
                                    _createVNode(_component_vue_datepicker, {
                                        modelValue: selectedPeriod.value,
                                        "onUpdate:modelValue": [
                                            _cache[1] || (_cache[1] = ($event) => ((selectedPeriod).value = $event)),
                                            handleChangeDatePicker
                                        ],
                                        range: "",
                                        "month-picker": "",
                                        position: "left",
                                        format: _unref(selectedMonthFormat),
                                        "model-type": _unref(selectedMonthFormat),
                                        "min-date": minMonth.value,
                                        "max-date": maxMonth.value,
                                        onRangeStart: handleStartRangeMonthPicker,
                                        onRangeEnd: handleEndRangeMonthPicker
                                    }, {
                                        "action-row": _withCtx((props) => [
                                            _createVNode(_component_vue_datepicker_action_row, _mergeProps(props, { "display-format": _unref(selectedMonthFormat) }), null, 16 /* FULL_PROPS */, ["display-format"])
                                        ]),
                                        "dp-input": _withCtx(() => [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createElementVNode("span", _hoisted_6, _toDisplayString(locale.selectPeriod), 1 /* TEXT */),
                                                _createVNode(_component_v_text_field, {
                                                    value: formattedPeriod.value,
                                                    variant: "outlined",
                                                    density: "compact",
                                                    readonly: "",
                                                    "hide-details": "",
                                                    class: "mt-1",
                                                    "bg-color": "white",
                                                    "prepend-inner-icon": "mdi-calendar-month-outline"
                                                }, null, 8 /* PROPS */, ["value"])
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "format", "model-type", "min-date", "max-date"])
                                ])
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                        _createCommentVNode(" 라이더 상태 "),
                        _createElementVNode("div", null, [
                            _createVNode(Select, {
                                width: 150,
                                title: locale.workerUseYn,
                                value: workerUseYn.value,
                                items: _unref(workerProfitUseYnTypeOptionList),
                                "on-change": handleChangeWorkerUseYnSelector
                            }, null, 8 /* PROPS */, ["title", "value", "items"])
                        ]),
                        _createCommentVNode(" 상점 종류 "),
                        _createElementVNode("div", null, [
                            _createVNode(Select, {
                                width: 150,
                                title: locale.storeType,
                                value: storeType.value,
                                items: _unref(workerProfitStoreTypeOptionList),
                                "on-change": handleChangeStoreTypeSelector
                            }, null, 8 /* PROPS */, ["title", "value", "items"])
                        ]),
                        _createCommentVNode(" 원천세 여부 "),
                        _createElementVNode("div", null, [
                            _createVNode(Select, {
                                width: 150,
                                title: locale.isWithholdingTax,
                                value: isWithholdingTax.value,
                                items: _unref(workerProfitIsWithholdingTaxTypeOptionList),
                                "on-change": handleChangeIsWithholdingTaxSelector
                            }, null, 8 /* PROPS */, ["title", "value", "items"])
                        ]),
                        _createCommentVNode(" 초기화 "),
                        _createElementVNode("div", null, [
                            _createVNode(_component_v_btn, {
                                class: "brg-btn size-l outlined info",
                                variant: "text",
                                onClick: handleClickResetBtn
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                        icon: "mdi-restart",
                                        size: "16"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(locale.reset), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(SearchInputWrapper, null, {
                            default: _withCtx(() => [
                                _createCommentVNode(" 검색 유형 "),
                                _createVNode(Select, {
                                    width: 100,
                                    value: searchType.value,
                                    items: _unref(workerProfitSearchTypeOptionList),
                                    "on-change": handleChangeSearchTypeSelector
                                }, null, 8 /* PROPS */, ["value", "items"]),
                                _createCommentVNode(" 검색어 "),
                                _createVNode(SearchInput, {
                                    placeholder: locale.searchPlaceholder,
                                    "on-search": handleChangeSearchKeyInput,
                                    "default-value": searchKey.value
                                }, null, 8 /* PROPS */, ["placeholder", "default-value"])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
